<template>
  <div class="">
<!--body content start-->

<div id="main-page" class="page-content">

<!--pricing table start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <div class="price-table theme-bg">
          <div class="price-header">
            <h4 class="price-title">Free</h4>
            <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum</p>
          </div>
          <div class="price-value">
            <h2>
              <span class="price-dollar">$</span>23
            </h2>
          </div>
          <div class="price-list">
            <ul class="list-unstyled">
              <li><i class="fas fa-check"></i> Free Domian</li>
              <li><i class="fas fa-check"></i> 500 MB Storage</li>
              <li><i class="fas fa-check"></i> 20 Database</li>
              <li><i class="fas fa-check"></i> Unlimited Site licenses</li>
              <li><i class="fas fa-check"></i> Professional Support</li>
            </ul>
          </div>
          
          <a class="btn btn-white btn-block mt-4" href="#"> <span>Get Started <i class="fas fa-long-arrow-alt-right ml-2"></i></span>
          </a>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 md-mt-5">
        <div class="price-table box-shadow">
          <div class="price-header">
            <h4 class="price-title">Standard</h4>
            <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum</p>
          </div>
          <div class="price-value">
            <h2>
              <span class="price-dollar">$</span>88
            </h2>
          </div>
          <div class="price-list">
            <ul class="list-unstyled">
              <li><i class="fas fa-check"></i> Free Domian</li>
              <li><i class="fas fa-check"></i> 500 MB Storage</li>
              <li><i class="fas fa-check"></i> 20 Database</li>
              <li><i class="fas fa-check"></i> Unlimited Site licenses</li>
              <li><i class="fas fa-check"></i> Professional Support</li>
            </ul>
          </div>          
          <a class="btn btn-theme btn-block mt-4" href="#"> <span>Get Started <i class="fas fa-long-arrow-alt-right ml-2"></i></span>
          </a>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 md-mt-5">
        <div class="price-table dark-bg">
          <div class="price-header">
            <h4 class="price-title">Premium</h4>
            <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum</p>
          </div>
          <div class="price-value">
            <h2>
              <span class="price-dollar">$</span>139
            </h2>
          </div>
          <div class="price-list">
            <ul class="list-unstyled">
              <li><i class="fas fa-check"></i> Free Domian</li>
              <li><i class="fas fa-check"></i> 500 MB Storage</li>
              <li><i class="fas fa-check"></i> 20 Database</li>
              <li><i class="fas fa-check"></i> Unlimited Site licenses</li>
              <li><i class="fas fa-check"></i> Professional Support</li>
            </ul>
          </div>          
          <a class="btn btn-white btn-block mt-4" href="#"> <span>Get Started <i class="fas fa-long-arrow-alt-right ml-2"></i></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!--pricing table end-->


</div>

<!--body content end--> 
  </div>
</template>

<script>


export default {
    data: function () {
        return {
            name: 'pricing',
        }
    },
};
</script>
